/* eslint-disable no-template-curly-in-string */

const getDXPBasePath = (): string => {
  const basePaths = window.location.pathname.split("/s/")[0];
  if (basePaths) {
    return `${window.location.pathname.split("/s/")[0]}/s/registration`;
  }
  return `${window.partnerRegistrationConfig?.dxpBasepath ?? ""}/registration`;
};

export const SESSION_AUTH_KEY = `adobeid_ims_profile/${window?.partnerRegistrationConfig?.REACT_APP_CLEINT_ID}/false/AdobeID,openid`;

export const SESSION_TOKEN_KEY = `adobeid_ims_access_token/${window?.partnerRegistrationConfig?.REACT_APP_CLEINT_ID}/false/AdobeID,openid`;

const getUserData = () => {
  const sessionData: any = sessionStorage.getItem(SESSION_AUTH_KEY);
  const userSessionData: any = JSON.parse(sessionData);
  return userSessionData;
};

export const PROGRAM_TYPE: any = {
  DXP: "dxp",
};

export const PAGE_PARAMS: any = {
  "90001": "dxp",
};

export const ACCOUNT_STATUS = {
  APPROVED: "Approved",
  SUBMITTED_IN_REVIEW: "Submitted In Review",
  PARTIALLY_SAVED: "Partially Saved",
  MISSING_PAYMENT: "Missing Payment",
  LOCKED: "Locked",
};

export const ACCOUNT_STATUS_TEXT: any = {
  Approved: "Approved",
  "Submitted In Review": "Under Review",
  "Partially Saved": "Partially Submitted",
  Pending: "Partially Submitted",
};

export const HEADER_FOOTER_TEMPLATES_NAME: any = {
  dxp: {
    authPartnershipHeader: "dxp-partnership-header",
    header: "dxp-header",
    footer: "",
    authFooter: "",
    authHeader: "dxp-header-auth",
  },
};

export const ERROR_CODES = [401, 403];
export const ERROR_TYPE = ["ServerError", "UnAuthorized"];
export const ERROR_MSG = {
  required: "This field is required",
  invalid: "Please select a valid company",
};

export const PROXY_URL = [
  "enterprise-sales.qa.adobe.com",
  "partners.stage.adobe.com",
  "partners.adobe.com",
  "localhost.corp.adobe.com:3000",
];

export const PROGRAM_ID = "DXP";

/**
 * Router path for the registration wizard **relative to BrowserRouter basename**.
 * Basename already ends with `.../registration`, so this must stay `/` to avoid URLs like `.../registration/registration`.
 */
export const DXP_REGISTRATION_ROUTE = "/";

export const ALREADY_REGISTERED_LABEL: any = {
  DXP: "Digital Experience Partner Program",
};

export const PROGRAM_SPECIFIC_NAMES: any = {
  DXP: {
    programType: PROGRAM_TYPE.DXP,
    route: {
      basePath: getDXPBasePath(),
      pendingApproval: `/pending-approval`,
      alreadyRegisteredWithAnotherProgram: `/already-registered-with-another-program`,
      registeredWithAnotherProgram: `/registered-with-another-program`,
      registration: DXP_REGISTRATION_ROUTE,
      requestSubmitted: `/request-submitted`,
      saveSuccess: `/save-success`,
      alreadyRegistered: `/already-registered`,
      requestPending: `/request-pending`,
      sameDomainContactInactive: `/same-domain-contact-inactive`,
      differentDomainContactInactive: `/different-domain-contact-inactive`,
      inviteContact: `/invited-contact-registration`,
      invalidContact: `/invalid-contact`,
      continueRegistration: `/continue-registration`,
      emailMismatch: `/email-mismatch`,
    },
    partnerProgram: {
      type: "DXP",
      program: PROGRAM_TYPE.DXP,
      title: "Digital Experience Partner Program",
      logoLink: `https://www.adobe.com/federal/assets/svgs/adobe-logo.svg`,
      termsConditionsLink:
        "https://d38k06t7m3x001.cloudfront.net/public-shared/DXP-onboarding-terms-and-conditions.pdf",
      partnerTitle: "Adobe Digital Experience Partner",
      alreadyRegisteredTo: "Solution Partner Program",
      fullName: "Adobe Digital Experience Partner",
      helpText: {
        preLinkText: "Questions? Contact",
        linkText: "Contact the Digital Experience Partner Support team",
      },
      adobeProgramName: "Adobe Digital Experience Partner Program",
      continueRegistration: {
        program: "Adobe Digital Experience Program",
      },
      portal: "Digital Experience Partner Portal",
      portalTeam: "Digital Experience Partner Team",
      portalLink: "https://partners.adobe.com/dxp/home.html",
      homePage: window?.partnerRegistrationConfig?.REACT_APP_DXP_URL,
      userData: getUserData(),
      companyName: localStorage.getItem("companyName"),
      requestSubmitted: {
        message:
          "For the best experience please make sure to complete your profile and select your interests.",
      },
      newRequestSubmitted: {
        title:
          "Within 3 business days, we will send an email to you if your application has been approved.",
        subTitle: "Thank you for your interest in partnering with Adobe.",
      },
    },
    gNav: {
      jslib:
        window.partnerRegistrationConfig?.feds?.jslib ||
        "https://www.stage.adobe.com/etc.clientlibs/globalnav/clientlibs/base/feds.js",
      fedsConfig: {
        locale: "en",
        disableSticky: true,
        jarvis: {
          surfaceName: "dxp_default",
          surfaceVersion: "1.0",
        },
        content: {
          experience:
            window.partnerRegistrationConfig?.feds?.dxpExperience ||
            "dxp-public-gnav/all",
        },
      },
    },
    endpoints: {
      findPartnerUrl: `${
        window?.partnerRegistrationConfig?.REACT_APP_API_URL
      }/api/v1/${PROGRAM_TYPE.DXP.toUpperCase()}/partner/search?email=`,
    },
    manageProfile: {
      personalInfo: `${window?.partnerRegistrationConfig?.REACT_MANAGE_PROFILE_DXP}/user-profile/overview`,
    },
  },
};

export const PARTNERSHIP_LEVEL = [
  "Exchange Member",
  "Innovate Partner",
  "Accelerate Partner",
  "Premier Partner",
  "Innovate Trial",
  "Community",
  "Silver",
  "Gold",
  "Platinum",
];

export const PARTNERSHIP_LEVEL_NAME: any = {
  "Exchange Member": "Exchange Member",
  "Innovate Partner": "Innovate",
  "Accelerate Partner": "Accelerate",
  "Premier Partner": "Premier",
  "Innovate Trial": "Innovate Trial",
  Community: "Community",
  Silver: "Silver",
  Gold: "Gold",
  Platinum: "Platinum",
};

export const PARTNERSHIP_LEVEL_COLOR: any = {
  "Exchange Member": "#808285",
  "Innovate Partner": "#58595B",
  "Accelerate Partner": "#231F20",
  "Premier Partner": "#EB1000",
  "Innovate Trial": "#808285",
  Community: "#808285",
  Silver: "#58595B",
  Gold: "#231F20",
  Platinum: "#EB1000",
};

export const STATUS_COLOR: any = {
  info: "#1473E6",
  alert: "#D7373F",
  success: "#268E6C",
};

export const MEMBERSHIP_STATUS = [
  "Renew Submitted",
  "Upgrade Submitted",
  "Payment Requested",
  "Approved",
  "Submitted In Review",
];

export const REGISTRATION_TYPE = ["Renewal", "Uplevel"];
export const AGREEMENT_CONTEXT = ["Pre Sign", "Post Sign"];

// Agreement names
export const AGREEMENT_NAMES: any = {
  "Exchange Member": "Adobe Technology Partner Primary Agreement",
  "Innovate Partner": "Silver Agreement",
  "Accelerate Partner": "Accelerate Agreement",
  "Premier Partner": "Premier Agreement",
  Community: "Adobe Technology Partner Primary Agreement",
  Silver: "Silver Agreement",
  Gold: "Gold Agreement",
  Platinum: "Platinum Agreement",
};

export const PAYMENT_STATUS = ["Requested", "Pending", "Completed"];
export const PAYMENT_MESSAGE: any = {
  Pending:
    "You paid via wire transfer. Validation may take up to 2, 3 days. Once the process is finalized we’ll inform you via email.",
  Completed: "Payment received. Your request will be finalized shortly.",
};

export const PAYMENT_BUTTON_STYLE: any = {
  fontSize: "14px",
  fontWeight: "bold",
  color: "#ffffff",
  padding: "7px 11px 7px 11px",
  border: "2px solid #1473E6",
  backgroundColor: "#1473E6",
};

export const SILVER_RENEWAL: any = {
  accountLevel: PARTNERSHIP_LEVEL_NAME.Silver,
  level: PARTNERSHIP_LEVEL_NAME.Silver,
  membershipStatus: MEMBERSHIP_STATUS[4],
  registrationType: REGISTRATION_TYPE[0],
};
